import styled from 'styled-components';

const ViewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-inline: 15px;
    padding-block: 8px;
    height: calc(100vh - 100px);
    gap: 24px;
`;

const HeaderViewWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 60px;
`;

const ContentViewWrapper = styled.div`
    flex: 1;
`;

const MessageBody = styled.div`
  padding: 12px 16px;
  border-radius: 16px;
  background-color: ${props => props.isAgent ? '#FAFAFA' : '#3177eef0'};
  border: 1px solid ${props => props.isAgent ? '#E5E7EB' : '#e9ecf3'};
  color: ${props => props.isAgent ? '#1F2937' : '#FFFFFF'};
  font-size: 14px;
  line-height: 1.6;
  margin: ${props => props.isAgent ? '0 0 0 8px' : '0 8px 0 0'};
  word-wrap: break-word;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props => props.isAgent ? '#D1D5DB' : 'none'};
  }

  .markdown-content, .html-content {
    width: 100%;
    overflow-x: auto;
    
    table {
      border-collapse: collapse;
      width: 100%;
      margin: 8px 0;
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #E5E7EB;

      th, td {
        border: 1px solid #E5E7EB;
        padding: 8px 12px;
        text-align: left;
      }

      th {
        background-color: #F9FAFB;
        font-weight: 600;
      }

      tr:nth-child(even) {
        background-color: #F9FAFB;
      }
    }

    pre {
      background-color: #F9FAFB;
      padding: 12px;
      border-radius: 8px;
      overflow-x: auto;
      margin: 8px 0;
      border: 1px solid #E5E7EB;
    }

    code {
      background-color: #F9FAFB;
      padding: 2px 6px;
      border-radius: 4px;
      font-family: 'Fira Code', monospace;
      font-size: 0.9em;
      color: #374151;
    }

    p {
      margin: 4px 0;
    }

    ul, ol {
      margin: 8px 0;
      padding-left: 24px;
    }

    li {
      margin: 4px 0;
    }

    blockquote {
      border-left: 4px solid #E5E7EB;
      margin: 8px 0;
      padding: 8px 16px;
      color: #4B5563;
      background-color: #F9FAFB;
      border-radius: 0 8px 8px 0;
    }

    a {
      color: #2563EB;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }

    img {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
      margin: 8px 0;
    }

    h1, h2, h3, h4, h5, h6 {
      margin: 16px 0 8px;
      color: #111827;
    }
  }
`;

export {
  ViewWrapper,
  HeaderViewWrapper,
  ContentViewWrapper,
  MessageBody
};
